import { OptionProps, Select, chakraComponents } from "chakra-react-select";
import { selectChakraStyles } from "utils/constants";
import { useEffect, useState } from "react";
import { Text, VStack } from "@chakra-ui/react";
import { useBorrowers } from "hooks/useBorrowers";
import { useLenders } from "hooks/useLenders";

export type MemberOption = {
  label: string;
  value: string;
  type: string;
  role: string;
  is_active: boolean;
};

const customComponents = {
  Option: ({ children, ...props }: OptionProps) => {
    const data: {
      label: string;
      role: string;
      type: string;
    } = props.data as any;
    return (
      <chakraComponents.Option {...props}>
        <VStack alignItems="flex-start" spacing="0px">
          <Text>{data.label}</Text>
          <Text fontSize="13px" color="gray.600">
            {data.role} &bull; {data.type === "lender" ? "Lender" : "Borrower"}
          </Text>
        </VStack>
      </chakraComponents.Option>
    );
  },
};

const MembersField = ({
  setMembers,
  members,
  isMulti,
  exclude = [],
  borrowerCompanyId,
  types = [],
  isRequired = true,
}: {
  setMembers: (payload: MemberOption[]) => void;
  members: any;
  isMulti?: boolean;
  exclude: string[];
  borrowerCompanyId?: string;
  types?: ("lender" | "borrower")[];
  isRequired?: boolean;
}) => {
  const { lenders = [] } = useLenders({ enabled: types?.includes("lender") });
  const { borrowers = [] } = useBorrowers({
    enabled: types?.includes("borrower"),
    borrowerCompanyId,
  });

  const [options, setOptions] = useState<MemberOption[]>([]);

  useEffect(() => {
    setOptions(
      [
        ...lenders.map(lender => ({
          label: `${lender.first_name} ${lender.last_name}`,
          value: lender.id,
          type: "lender",
          role: lender.role.name,
          is_active: lender.is_active === true,
        })),
        ...borrowers.map(borrower => ({
          label: `${borrower.first_name} ${borrower.last_name}`,
          value: borrower.id,
          type: "borrower",
          role: borrower.role.name,
          is_active: borrower.is_active === true,
        })),
      ].sort((a, b) => a.label.localeCompare(b.label))
    );
  }, [lenders, borrowers]);

  console.log(options);

  return (
    <Select
      isMulti={isMulti}
      isClearable={false}
      useBasicStyles
      selectedOptionColor="black"
      colorScheme="purple"
      variant="outline"
      focusBorderColor="gray.50"
      chakraStyles={selectChakraStyles}
      value={members}
      components={customComponents}
      onChange={(newValue: MemberOption | unknown) => setMembers(newValue as MemberOption[])}
      options={options.filter((record: any) => !exclude.includes(record.value))}
      isRequired={isRequired}
    />
  );
};

export default MembersField;
